module.exports = __webpack_public_path__ + "static/media/E4.bd49c06c.jpeg";